import React from "react";
import { FaArrowRightLong } from "react-icons/fa6";
import { Link, useNavigate } from "react-router-dom";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import useSnackbar from "../../../hooks/useSnackbar";
import { AuthService } from "../../../services";
import { useForm } from "react-hook-form";
import { joiResolver } from "@hookform/resolvers/joi";
import { sendMobileOtpValidation } from "../../../validations";
import { useMutation } from "@tanstack/react-query";
import ButtonLoader from "../../../component/buttonLoader";

const Number = () => {
  const navigate = useNavigate();
  const { snackbar } = useSnackbar();
  const { sendOtp } = AuthService();
  const {
    register,
    getValues,
    setValue,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: joiResolver(sendMobileOtpValidation),
    defaultValues: {
      mobile: "",
      countryCode: ""
    }
  });

  const sendOtpMutation = useMutation({
    mutationFn: (data) => {
      return sendOtp({ ...data, type: "reset_password" })
    },
    onSuccess: (data) => {
      navigate("/otp", {
        state: {
          ...getValues(),
          screen: "forgot"
        }
      })
      snackbar((data?.message || ""), "info");
    },
    onError: (err) => {
      snackbar((err.data.message || ""));
    }
  });


  return (
    <div className="signup_wrap">
      <form onSubmit={handleSubmit(sendOtpMutation.mutate)}>
        <div className="form_field">
          <label className="label" htmlFor="">
            Mobile Number
          </label>
          <PhoneInput
            placeholder="Enter Number"
            country={"in"}
            onChange={(fullNumber, dialCodeDetail) => {
              const mobile = fullNumber.replace(`${dialCodeDetail?.dialCode}`, "");
              const countryCode = dialCodeDetail?.dialCode;
              setValue("mobile", mobile);
              setValue("countryCode", countryCode);
            }}
          />
          {errors.mobile && <span className="error">{errors.mobile?.message}</span>}
        </div>
        <div className="btn_wrap_login">
          <ButtonLoader
            text={<>Verify <FaArrowRightLong /></>}
            className="login"
            isLoading={sendOtpMutation.isPending}
          />
        </div>
      </form>
    </div>
  );
};

export default Number;
